<template>
  <div id="dealDetailsComponent">
    <template v-if="defaultValue.dealOriginType != 2">
      <div style="display: flex;padding-top:5px;" v-if="!editMode">
        <div style="flex: 1;padding: 20px;background: #FCFCFC;">
          <a-row class="customer_name">{{ defaultValue.companyShortName }}</a-row>
          <a-row class="info_lines">
            <a-col :span="8" class="title">
              <div>{{ $t('deal.addDeal.dealDetails.projectPossible') }}:</div>
            </a-col>

            <a-col :span="8" class="title">
              <div>{{ $t('deal.addDeal.brokerage.totalBrokerage') }}:</div>
            </a-col>
            <a-col class="title" :span="8">
              <div>{{ $t('deal.addDeal.dealDetails.projectEndtime') }}:</div>
            </a-col>
            <a-col :span="8" class="title">
              <div class="content_text blackhillsYellow">{{ defaultValue.projectPossible | NumberFormat }}%</div>
            </a-col>
            <a-col :span="8" class="title">
              <div class="content_text blackhillsYellow">
                {{ defaultValue.totalBrokerage | NumberFormat }}
                <pt-unit-select type="currency" v-model="defaultValue.totalBrokerageUnit"
                                :edit-mode="false"></pt-unit-select>
              </div>
            </a-col>
            <a-col class="title" :span="8">
              <div class="content_text blackhillsYellow">{{ defaultValue.projectEndtime | dayjs('YYYY-MM') }}</div>
            </a-col>
          </a-row>
          <a-row class="info_lines">
            <a-col :span="8">
              <div class="title">{{ $t('deal.addDeal.dealDetails.demandArea') }}:</div>
            </a-col>

            <a-col class="title" :span="8">
              <div>{{ $t('deal.addDeal.dealDetails.budgetRent') }}:</div>
            </a-col>
            <a-col :span="8" class="title">
              <div>{{ $t('deal.addDeal.dealDetails.propertyType') }}</div>
            </a-col>
            <a-col :span="8">
              <div class="content_text">
                {{ defaultValue.demandArea | NumberFormat }}
                <pt-unit-select type="area" v-model="defaultValue.demandAreaUnit" :edit-mode="false"></pt-unit-select>
              </div>
            </a-col>
            <a-col class="title" :span="8">
              <div class="content_text">
                {{ defaultValue.budgetRent | NumberFormat }}
                <pt-unit-select type="rent" v-model="defaultValue.budgetRentUnit" :edit-mode="false"></pt-unit-select>
              </div>
            </a-col>
            <a-col :span="8">
              <div class="content_text">{{ $t('deal.propertyTypes.' + defaultValue.propertyType) }}</div>
            </a-col>
          </a-row>
          <a-row class="info_lines">
            <a-col :span="8" class="title">
              <div>{{ $t('deal.addDeal.dealSource.sourceType') }}</div>
            </a-col>
            <a-col :span="8" class="title">
              <div>{{ $t('deal.addDeal.dealDetails.priority') }}:</div>
            </a-col>
            <a-col :span="8" class="title">
              <div>{{ $t('deal.addDeal.dealDetails.dealSource') }}:</div>
            </a-col>
            <a-col :span="8">
              <div class="content_text">{{ getDealSourceType }}</div>
            </a-col>
            <a-col :span="8">
              <div class="content_text" style="color:#FABE00;">{{
                  priorityOptions.find(e => {
                    return e.wordKey == defaultValue.priority
                  }).wordValue
                }}
              </div>
            </a-col>
            <a-col :span="8">
              <div class="content_text">{{ dealSourceName }}</div>
            </a-col>
          </a-row>
          <a-row class="info_lines">
            <a-col :span="8">
              <div class="title">{{ $t('deal.addDeal.dealDetails.competitionSituation') }}:</div>
              <div class="content_text">{{
                  this.defaultValue.colleagueDOS != null ? defaultValue.colleagueDOS.map(e => {
                    return e.companySortNameCn
                  }).join(",") : '~'
                }}
              </div>
            </a-col>
            <a-col :span="16">
              <div class="title">{{ $t('deal.addDeal.dealDetails.targetArea') }}:</div>
              <div>
                <template v-if="defaultValue.targetArea!='~'">
                  <pt-multi-cascader
                    :editMode="false"
                    disabled
                    :value="JSON.parse(defaultValue.targetArea)"
                    :styleObj="{width: '100%'}"
                    size="small"
                    :options="allCityDatas"
                    :props="{multiple: true}"
                    :clearable="false"></pt-multi-cascader>
                </template>
                <template v-else>
                  ~
                </template>
              </div>
            </a-col>
          </a-row>
          <a-row>
            <a-col :span="24" class="title">
              <div>{{ $t('deal.addDeal.brokerage.remarks') }}:</div>
            </a-col>
            <a-col :span="24">
              <div class="content_text" style="word-break: break-word;">{{ defaultValue.remarks }}</div>
            </a-col>
          </a-row>
        </div>
        <div @click="toEditMode" v-if="!hideEdit">
          <pt-icon type="icon-bianji1" class="edit_icon"></pt-icon>
        </div>
      </div>
      <div v-else style="margin-top:5px;background: #FCFCFC;">
        <a-row class="save_form">
          <a-form layout="vertical" :form="form" selfUpdate>
            <div v-show="false">
              <a-form-item>
                <a-input v-decorator="['dealSourceVO.id']"></a-input>
              </a-form-item>
              <a-form-item>
                <a-input v-decorator="['dealOriginType']"></a-input>
              </a-form-item>
              <a-form-item :label="$t('dealConfirm.payerType.title')">
                <a-radio-group v-decorator="decorators.customerType" @change="customerTypeChange"
                               v-model="customerType">
                  <a-radio :value="3">{{ $t('dealConfirm.payerType.3') }}</a-radio>
                  <a-radio :value="1">{{ $t('dealConfirm.payerType.1') }}</a-radio>
                </a-radio-group>
              </a-form-item>
            </div>
            <a-row>
              <a-col :span="16">
                <a-form-item :label="$t('deal.addDeal.dealSource.sourcePerson')">
                  <pt-user-select v-decorator="decorators.dealSourcePersonStringList"
                                  :placeholder="$t('user.tips.select')" style="width: 150px" mode="multiple"
                                  maxTagCount="1"></pt-user-select>
                </a-form-item>
              </a-col>
              <a-col :span="8">
                <a-form-item :label="$t('deal.addDeal.dealSource.sourceType')">
                  <pt-select v-decorator="decorators.dealSourceTree" :allowClear="false">
                    <a-select-option v-for="d in leaseSourceTypeOptions" :key="d.wordKey" :value="d.wordKey">
                      {{ d.wordValue }}
                    </a-select-option>
                  </pt-select>
                </a-form-item>
              </a-col>
            </a-row>
            <a-row>
              <a-col :span="16">
                <a-form-item :label="$t('deal.addDeal.dealDetails.companyName')">
                  <a-select
                    showSearch
                    v-decorator="decorators.customerId"
                    :placeholder="$t('key14qingshuru')"
                    :defaultActiveFirstOption="false"
                    :showArrow="false"
                    :filterOption="false"
                    @search="handleSearch"
                    @change="buildProjectNameByCustomer"
                    :notFoundContent="null"
                  >
                    <a-icon slot="suffixIcon" type="caret-down"/>
                    <div slot="dropdownRender" slot-scope="menu">
                      <v-nodes :vnodes="menu"/>
                      <a-divider style="margin: 0;"/>
                      <div class="addCustomerBtn" @click="openAddCustomerModal">
                        <pt-icon type="icon-zengjia" class="addIcon"></pt-icon>
                        <div style="font-size: 12px;color: #ffffff;margin-left:4px;">
                          {{ customerType == 1 ? $t('track.trackModal.addCustomer') : $t('track.trackModal.addProprietor') }}
                        </div>
                      </div>
                    </div>
                    <a-select-option v-for="d in customerList" :key="d.id" :value="d.id">
                      <div style="display:flex;">
                        <div style="flex:1;" class="invisible-item">
                          {{ d.companyName }}
                        </div>
                        <div>
                          {{ d.companySortNameCn }}
                        </div>
                      </div>
                    </a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :span="8">
                <a-form-item :label="$t('deal.addDeal.dealDetails.projectName')">
                  <a-input v-decorator="decorators.projectName"></a-input>
                </a-form-item>
              </a-col>
            </a-row>
            <a-row>
              <a-col :span="8">
                <a-form-item :label="$t('deal.addDeal.dealDetails.propertyType')">
                  <ptSelect v-decorator="decorators.propertyType" :allowClear="false">
                    <a-select-option v-for="u in propertyTypes" :key="u.wordKey" :value="u.wordKey">{{ u.wordValue }}
                    </a-select-option>
                  </ptSelect>
                </a-form-item>
              </a-col>
              <a-col :span="8">
                <a-form-item :label="$t('deal.addDeal.dealDetails.demandArea')">
                  <a-input-group compact>
                    <pt-input-number style="width:70%;" v-decorator="decorators.demandArea" :max="9999999999"
                                     :precision="2" :min="0"
                    ></pt-input-number>
                    <pt-unit-select style="width: 30%;" type="area" v-decorator="decorators.demandAreaUnit"
                                    disabled></pt-unit-select>
                  </a-input-group>
                </a-form-item>
              </a-col>
              <a-col :span="8">
                <a-form-item :label="$t('deal.addDeal.dealDetails.budgetRent')">
                  <a-input-group compact>
                    <pt-input-number :precision="2" style="width:45%;" v-decorator="decorators.budgetRent" :max="99999"
                                     :min="0"
                    ></pt-input-number>
                    <pt-unit-select style="width: 55%;" type="rent" v-decorator="decorators.budgetRentUnit"
                                    disabled></pt-unit-select>
                  </a-input-group>
                </a-form-item>
              </a-col>
            </a-row>
            <a-row>
              <a-form-item :label="$t('deal.addDeal.dealDetails.projectStages')" v-show="false">
                <ptSelect v-decorator="decorators.projectStages">
                </ptSelect>
              </a-form-item>
              <a-col :span="8">
                <a-form-item :label="$t('deal.addDeal.dealDetails.dealType')" class="required">
                  <ptSelect v-decorator="decorators.dealType" :allowClear="false" @change="buildProjectNameByDealType"
                            mode="multiple"
                            :maxTagTextLength="1" :maxTagCount="1">
                    <a-select-option v-for="u in dealTypes" :key="u.wordKey" :value="u.wordKey">{{ u.wordValue }}
                    </a-select-option>
                  </ptSelect>
                </a-form-item>
              </a-col>
              <a-col :span="8">
                <a-form-item :label="$t('deal.addDeal.dealDetails.projectEndtime')" class="required">
                  <pt-month-picker v-decorator="decorators.projectEndtime" :blackhillsYellow="true" style="width: 100%;"
                                   :disabledDate="disabledMonthDate"></pt-month-picker>
                </a-form-item>
              </a-col>
              <a-col :span="8">
                <a-form-item :label="$t('deal.addDeal.dealDetails.projectPossible')">
                  <pt-slider :blackhills-yellow="true"
                             :edit-mode="!disabled" :old-step="currProjectPossible" @changeStep="changePossible"
                             ref="possibleSliderRef"></pt-slider>
                </a-form-item>
              </a-col>
            </a-row>
            <a-row>
              <a-row>
                <a-col :span="8">
                  <a-form-item :label="$t('deal.addDeal.dealDetails.priority')">
                    <ptSelect :placeholder="$t('track.trackModal.priorityTip')" v-decorator="decorators.priority"
                              :allow-clear="false">
                      <a-select-option v-for="c in priorityOptions" :key="c.wordKey" :value="c.wordKey">
                        <span class="blackhillsYellow">
                          {{ c.wordValue }}
                        </span>
                      </a-select-option>
                    </ptSelect>
                  </a-form-item>
                </a-col>
                <a-col :span="8">
                  <a-form-item :label="$t('deal.addDeal.brokerage.totalBrokerage')">
                    <a-input-group compact>
                      <pt-input-number :precision="2" style="width:65%;"
                                       :blackhillsYellow="true"
                                       :placeholder="$t('deal.addDeal.brokerage.totalBrokerageTips')"
                                       v-decorator="decorators.totalBrokerage" :max="99999999"
                                       :min="0"></pt-input-number>
                      <pt-unit-select style="width: 35%;" type="currency" v-decorator="decorators.totalBrokerageUnit"
                                      disabled></pt-unit-select>
                    </a-input-group>
                  </a-form-item>
                </a-col>
              </a-row>
              <a-col :span="24">
                <a-form-item :label="$t('deal.addDeal.dealDetails.competitionSituation')">
                  <ptSelect mode="multiple" v-model="colleagueList" :maxTagCount="3" :maxTagTextLength="8">
                    <a-select-option v-for="c in competitors" :key="c.id" :value="c.id">
                      <div style="display:flex;">
                        <div style="flex:1;" class="invisible-item">
                          {{ c.companyName }}
                        </div>
                        <div>
                          {{ c.companySortNameCn }}
                        </div>
                      </div>
                    </a-select-option>
                  </ptSelect>
                </a-form-item>
              </a-col>
            </a-row>
            <a-row>
              <a-col :span="24">
                <a-form-item :label="$t('deal.addDeal.dealDetails.targetArea')">
                  <pt-multi-cascader
                    v-decorator="decorators.targetArea"
                    size="small"
                    :options="cityDatas"
                    :props="{multiple: true}"
                    collapse-tags
                    clearable></pt-multi-cascader>
                </a-form-item>
              </a-col>
            </a-row>
            <a-row>
              <a-col>
                <a-form-item :label="$t('deal.addDeal.brokerage.remarks')">
                  <ptInput mode="multiple" type="textarea" v-decorator="decorators.remarks"
                           :autosize="{minRows:3,maxRows:3}">
                  </ptInput>
                </a-form-item>
              </a-col>
            </a-row>
          </a-form>
        </a-row>
      </div>
    </template>
    <template v-else>
      <div style="display: flex;padding-top:5px;" v-if="!editMode">
        <div style="flex: 1;padding: 20px;background: #FCFCFC;">
          <a-row class="customer_name">{{ defaultValue.companyName }}</a-row>
          <a-row class="info_lines">
            <a-col :span="8">
              <div class="title">{{ $t('deal.addDeal.dealDetails.projectName') }}:</div>
            </a-col>
            <a-col :span="8" class="title">
              <div>{{ $t('deal.addDeal.dealDetails.projectPossible') }}:</div>
            </a-col>
            <a-col :span="8" class="title">
              <div>{{ $t('deal.addDeal.brokerage.totalBrokerage') }}:</div>
            </a-col>
            <a-col :span="8">
              <div class="content_text">
                {{ defaultValue.projectName }}
              </div>
            </a-col>
            <a-col :span="8" class="title">
              <div class="content_text blackhillsYellow">{{ defaultValue.projectPossible | NumberFormat }}%</div>
            </a-col>
            <a-col :span="8" class="title">
              <div class="content_text blackhillsYellow">
                {{ defaultValue.totalBrokerage | NumberFormat }}
                <pt-unit-select type="currency" v-model="defaultValue.totalBrokerageUnit"
                                :edit-mode="false"></pt-unit-select>
              </div>
            </a-col>
          </a-row>
          <a-row class="info_lines">
            <a-row>
              <a-col :span="8" class="title">
                <div>{{ $t('deal.addDeal.dealDetails.projectEndtime') }}:</div>
              </a-col>
              <a-col :span="8" class="title">
                <div>{{ $t('deal.addDeal.dealDetails.priority') }}:</div>
              </a-col>
              <a-col class="title" :span="8">
                <div>{{ $t('deal.addDeal.dealSource.sourceType') }}:</div>
              </a-col>
            </a-row>
            <a-row>
              <a-col :span="8" class="title">
                <div class="content_text blackhillsYellow">{{ defaultValue.projectEndtime | dayjs('YYYY-MM') }}</div>
              </a-col>
              <a-col :span="8">
                <div class="content_text blackhillsYellow">{{
                    priorityOptions.find(e => {
                      return e.wordKey == defaultValue.priority
                    }).wordValue
                  }}
                </div>
              </a-col>
              <a-col class="title" :span="8">
                <div class="content_text">
                  {{ getDealSourceType }}
                </div>
              </a-col>
            </a-row>
          </a-row>
        </div>
        <div @click="toEditMode" v-if="!hideEdit">
          <pt-icon type="icon-bianji1" class="edit_icon"></pt-icon>
        </div>
      </div>
      <div v-else style="margin-top:5px;background: #FCFCFC;">
        <a-row class="save_form">
          <a-form layout="vertical" :form="form" selfUpdate>
            <a-form-item v-show="false">
              <a-input v-decorator="['dealOriginType']"></a-input>
            </a-form-item>
            <a-form-item :label="$t('deal.addDeal.dealDetails.projectStages')" v-show="false">
              <ptSelect v-decorator="decorators.projectStages">
              </ptSelect>
            </a-form-item>
            <a-row>
              <a-form-item :label="$t('dealConfirm.payerType.title')">
                <a-radio-group v-decorator="decorators.customerType" @change="customerTypeChange">
                  <a-radio :value="3">{{ $t('dealConfirm.payerType.3') }}</a-radio>
                  <a-radio :value="1">{{ $t('dealConfirm.payerType.1') }}</a-radio>
                </a-radio-group>
              </a-form-item>
            </a-row>
            <a-row>
              <a-col :span="8">
                <a-form-item v-show="false">
                  <a-input v-decorator="decorators.dealType"></a-input>
                </a-form-item>
                <a-form-item :label="$t('deal.addDeal.dealDetails.projectName')">
                  <a-input v-decorator="decorators.projectName"></a-input>
                </a-form-item>
              </a-col>
              <a-col :span="16">
                <a-form-item :label="$t('deal.addDeal.dealDetails.companyName')" class="required">
                  <a-select
                    showSearch
                    v-decorator="decorators.customerId"
                    :placeholder="$t('deal.contract.addContract.companyNamePlaceholder')"
                    :defaultActiveFirstOption="false"
                    :showArrow="false"
                    :filterOption="false"
                    @search="handleSearch"
                    @change="buildProjectNameByCustomer"
                    :notFoundContent="null"
                  >
                    <a-icon slot="suffixIcon" type="caret-down"/>
                    <div slot="dropdownRender" slot-scope="menu">
                      <v-nodes :vnodes="menu"/>
                      <a-divider style="margin: 0;"/>
                      <div class="addCustomerBtn" @click="openAddCustomerModal">
                        <pt-icon type="icon-zengjia" class="addIcon"></pt-icon>
                        <div style="font-size: 12px;color: #ffffff;margin-left:4px;">
                          {{ customerType == 1 ? $t('track.trackModal.addCustomer') : $t('track.trackModal.addProprietor') }}
                        </div>
                      </div>
                    </div>
                    <a-select-option v-for="d in customerList" :key="d.id" :value="d.id">
                      <div style="display:flex;width:100%;">
                        <div style="flex:1;" class="invisible-item">
                          {{ d.companyName }}
                        </div>
                        <div>
                          {{ d.companySortNameCn }}
                        </div>
                      </div>
                    </a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
            </a-row>
            <a-row>
              <a-col :span="8">
                <a-form-item :label="$t('deal.addDeal.dealSource.sourceType')" class="required">
                  <pt-select v-decorator="decorators.dealSourceType" :allowClear="false">
                    <a-select-option v-for="d in dealSourceTypeOptions" :key="d.wordKey" :value="d.wordKey">
                      {{ d.wordValue }}
                    </a-select-option>
                  </pt-select>
                </a-form-item>
              </a-col>
              <a-col :span="8">
                <a-form-item :label="$t('deal.addDeal.dealDetails.projectPossible')">
                  <pt-slider :edit-mode="!disabled" :old-step="currProjectPossible" @changeStep="changePossible"
                             ref="possibleSliderRef"
                             :blackhills-yellow="true"></pt-slider>
                </a-form-item>
              </a-col>
              <a-col :span="8">
                <a-form-item :label="$t('deal.addDeal.dealDetails.projectEndtime')">
                  <pt-month-picker v-decorator="decorators.projectEndtime" :blackhillsYellow="true" style="width:100%;"
                                   :disabledDate="disabledMonthDate"></pt-month-picker>
                </a-form-item>
              </a-col>
            </a-row>
            <a-row>
              <a-col :span="8">
                <a-form-item :label="$t('deal.addDeal.brokerage.totalBrokerage')">
                  <a-input-group compact>
                    <pt-input-number :precision="2" style="width:65%;"
                                     :blackhillsYellow="true"
                                     :placeholder="$t('deal.addDeal.brokerage.totalBrokerageTips')"
                                     v-decorator="decorators.totalBrokerage" :max="99999999" :min="0"></pt-input-number>
                    <pt-unit-select style="width: 35%;" type="currency" v-decorator="decorators.totalBrokerageUnit"
                                    disabled></pt-unit-select>
                  </a-input-group>
                </a-form-item>
              </a-col>
              <a-col :span="8">
                <a-form-item :label="$t('deal.addDeal.dealDetails.priority')">
                  <ptSelect :placeholder="$t('track.trackModal.priorityTip')" v-decorator="decorators.priority"
                            :allow-clear="false">
                    <a-select-option v-for="c in priorityOptions" :key="c.wordKey" :value="c.wordKey">
                        <span class="blackhillsYellow">
                          {{ c.wordValue }}
                        </span>
                    </a-select-option>
                  </ptSelect>
                </a-form-item>
              </a-col>
            </a-row>
          </a-form>
        </a-row>
      </div>
    </template>
    <pt-modal :title="customerType == 1 ? customerModalTitle : proprietorModalTitle"
              :visible="customerModalVisible || proprietorModalVisible"
              @ok="saveCustomer" @cancel="cancelAddCustomer" :width="800"
    >
      <div slot="content">
        <add-customer ref="customerModel" v-model="customerModalTitle" @saveSuccess="saveCustomerSuccess"
                      v-if="customerModalVisible"></add-customer>
        <addProprietor v-if="proprietorModalVisible" v-model="proprietorModalTitle" ref="addProprietorRef"
                       @saveSuccess="saveProprietorSuccess"></addProprietor>
      </div>
    </pt-modal>
  </div>
</template>

<script>
import customerApi from '@/api/mine/customer'
import dealApi from '@/api/mine/deal'
import {getDatadictChildsByPath, findCascadingData} from '@/api/sys/datadict'
import colleagueApi from '@/api/database/colleague'
import accountApi from '@/api/mine/account'
import ownerApi from '@/api/database/owner'
import AddProprietor from '../../database/proprietor/module/addProprietor'
import addCustomer from '../../database/customer/module/addCustomer'

export default {
  name: 'dealDetailsComponent',
  components: {
    AddProprietor,
    addCustomer,
    VNodes: {
      functional: true,
      render: (h, ctx) => ctx.props.vnodes,
    },
  },
  data() {
    return {
      customerModalVisible: false,
      customerModalTitle: '',
      proprietorModalTitle: '',
      proprietorModalVisible: false,
      customerType: null,
      priorityOptions: [],
      currProjectPossible: 0,
      dealSourceTypeOptions: [],
      leaseSourceTypeOptions: [],
      dealSourceCascade: null,
      editMode: false,
      form: this.$form.createForm(this, {}),
      dealSourceTypes: [],
      dealSourcePersonStringList: [],
      dealSourcePaths: [],
      accountList: [],
      cityDatas: [],
      allCityDatas: [],
      customerList: [],
      colleagueList: [],
      propertyTypes: [],
      competitors: [],
      dealTypes: [],
      areaUnits: [],
      rentUnits: [],
      projectStages: [],
      decorators: {
        customerType: [
          'customerType', {}
        ],
        dealSourcePersonStringList: [
          'dealSourcePersonStringList', {
            rules: [
              {required: true, message: this.$t('deal.addDeal.errorInfo.dealSourcePersonStringList')},
              {
                validator: (rule, value, cb) => {
                  if (value.length > 3) {
                    cb(this.$t('deal.addDeal.errorInfo.dealSourcePersonLimit'))
                  } else {
                    cb()
                  }
                }
              }
            ]
          }
        ],
        targetArea: ['targetArea'],
        sourceType: [
          'dealSourceVO.sourceType', {rules: [{required: true, message: 'please select sourceType'}]}
        ],
        sourcePath: [
          'dealSourceVO.sourcePath', {rules: [{required: true, message: 'please select sourcePath'}]}
        ],
        dealSourceTree: [
          'dealSourceVO.sourceType', {
            rules: [{
              required: true,
              message: this.$t('deal.addDeal.errorInfo.dealSourceTree')
            }]
          }
        ],
        customerId: ['customerId', {
          rules: [{
            required: true,
            message: this.$t('deal.contract.addContract.companyNamePlaceholder')
          }], initialValue: undefined
        }],
        demandArea: [
          'demandArea', {}
        ],
        demandAreaUnit: [
          'demandAreaUnit', {}
        ],
        propertyType: [
          'propertyType', {}
        ],
        budgetRent: [
          'budgetRent', {}
        ],
        budgetRentUnit: [
          'budgetRentUnit', {}
        ],
        projectName: [
          'projectName', {}
        ],
        projectEndtime: [
          'projectEndtime', {
            rules: [{required: true, message: this.$t('deal.addDeal.errorInfo.projectEndtime')}]
          }
        ],
        demandType: [
          'demandType', {}
        ],
        dealType: [
          'dealType', {
            rules: [{required: true, message: this.$t('deal.addDeal.errorInfo.dealType')}]
          }
        ],
        projectStages: [
          'projectStages', {}
        ],
        projectPossible: [
          'projectPossible', {}
        ],
        competitionSituation: [
          'competitionSituation', {}
        ],
        remarks: [
          'remarks', {}
        ],
        totalBrokerage: [
          'totalBrokerage', {rules: []}
        ],
        totalBrokerageUnit: [
          'totalBrokerageUnit', {}
        ],
        brokerageRatio: [
          'brokerageRatio', {rules: []}
        ],
        dealSourceType: [
          'dealSourceVO.sourceType', []
        ],
        priority: [
          'priority', {}
        ],
      }
    }
  },
  props: {
    dealDetailsEditVisible: {
      type: Boolean,
      default: true,
    },
    defaultValue: {
      type: Object,
      default: () => {
        return {}
      }
    },
    hideEdit: {
      type: Boolean,
      default: false,
    }
  },
  mounted() {
    this.init()
  },
  computed: {
    dealSourceName() {
      let accountName = []
      this.accountList.forEach(e => {
        accountName[e.id] = e.loginName
      })
      return this.dealSourcePersonStringList.map(e => {
        return accountName[e]
      }).join(',')
    },
    getDealSourceType() {
      if (this.dealSourceTypeOptions.length > 0) {
        let defaultValue = this.defaultValue
        let sourceTypeOptions = this.dealSourceTypeOptions.concat(this.leaseSourceTypeOptions)
        return sourceTypeOptions.find(e => {
          return e.wordKey == defaultValue.dealSourceVO.sourceType
        }).wordValue
        // return this.dealSourceTypeOptions.find(e=>{return e.wordKey == defaultValue.dealSourceVO.sourceType}).wordValue
      } else {
        return ''
      }
    }
  },
  methods: {
    disabledMonthDate(current) {
      //禁用当前月之前的日期
      return current && current <= this.$moment().month(this.$moment().month() - 1).endOf('month');
    },
    changePossible() {
      this.currProjectPossible = this.$refs.possibleSliderRef.currStep;
    },
    buildProjectNameByCustomer(customerId) {
      let customerDO = this.customerList.find(e => {
        return e.id == customerId
      })
      let dealTypeIds = this.form.getFieldValue('dealType')
      let dealType = ''
      if (dealTypeIds) {
        for (let i = 0; i < dealTypeIds.length; i++) {
          dealType += this.$t('deal.dealTypes')[dealTypeIds[i]]
        }
      }
      this.form.setFieldsValue({projectName: customerDO.companySortNameCn + dealType})
    },
    buildProjectNameByDealType(dealTypeIds) {
      let customerDO = this.customerList.find(e => {
        return e.id == this.form.getFieldValue('customerId')
      })
      let dealType = ''
      for (let i = 0; i < dealTypeIds.length; i++) {
        dealType += this.$t('deal.dealTypes')[dealTypeIds[i]]
      }
      this.form.setFieldsValue({projectName: customerDO.companyName + dealType})
    },
    cancelEditMode() {
      this.editMode = false
      this.$emit('cancelEditMode')
    },
    customerTypeChange(value) {
      let customerType = value.target.value
      let customerId = undefined
      this.customerList = []
      this.customerType = customerType
      this.form.setFieldsValue({
        customerType: customerType,
        customerId: customerId
      })
      this.handleSearch(null)
    },
    handleSearch(customerName) {
      setTimeout(() => {
        let this_ = this
        if (this.customerType == 3) {
          ownerApi.queryByName({name: customerName}).then(res => {
            if (res.code == 1) {
              this_.customerList = res.data != null ? res.data : []
            }
          })
        } else {
          customerApi.queryByName({name: customerName}).then(res => {
            this_.customerList = res.data
          })
        }
      }, 300);
    },
    init() {
      if (this.defaultValue) {
        this.customerType = this.defaultValue.customerType;
      }
      this.initAccount()
      this.initCustomerList()
      this.initCompetitors()
      this.initDealTypes()
      this.initCustomerRelationShipOptions()
      this.initPropertyTypes()
      this.initServiceDealSourceTypes()
      this.initCityData()
    },
    initAccount() {
      accountApi.listAll().then(res => {
        this.dealSourcePersonStringList = this.defaultValue.dealSourceVO.dealSourcePersonDOS.map(e => {
          return e.userId
        })
        this.accountList = res.data
      })
    },
    initCustomerRelationShipOptions() {
      customerApi.getCustomerRelationShipOptions().then(res => {
        if (res.code == 1) {
          this.priorityOptions = res.data
          this.priorityOptions.sort((a, b) => {
            return a.listIndex - b.listIndex
          })
        }
      })
    },
    initCityData() {
      let this_ = this
      findCascadingData("system.mansion_set.address", 4).then(res => {
        this_.allCityDatas = res.data
        let data
        for (let i = 0; i < res.data.length; i++) {
          //只显示员工公司所在地
          data = this_.buildNewTree(res.data[i], this_.$store.getters.userInfo.companyDO.city.toLowerCase())
          if (data) {
            break
          }
        }
        this_.cityDatas = data
      })
    },
    buildNewTree(tree, equalsValue) {
      let stack = [tree]
      if (tree.value != equalsValue) {
        for (let i = 0; i < tree.children.length; i++) {
          if (tree.children[i].value == equalsValue) {
            return stack
          }
        }
      } else {
        return stack
      }
    },
    initCustomerList() {
      let this_ = this
      if (this.defaultValue.customerType == 3) {
        ownerApi.selectOne(this.defaultValue.customerId).then(res => {
          if (res.code == 1) {
            this.customerList = [res.data]
          } else {
          }
        })
      } else {
        customerApi.selectOne(this.defaultValue.customerId).then(res => {
          this_.customerList = [];
          this_.customerList.push(res.data)
        })
      }
    },
    initServiceDealSourceTypes() {
      let this_ = this
      getDatadictChildsByPath('system.business_key.deal_source_set').then(res => {
        this_.dealSourceTypeOptions = res.data.filter(e => {
          return e.wordKey == 'approach' || e.wordKey == 'invited'
        })
        this_.leaseSourceTypeOptions = res.data.filter(e => {
          return e.wordKey != 'approach' && e.wordKey != 'invited'
        })
      })
    },
    toEditMode() {
      this.editMode = true
      let defaultValue = JSON.parse(JSON.stringify(this.defaultValue))
      console.log("defaultValue", defaultValue)
      this.currProjectPossible = defaultValue.projectPossible;
      this.$nextTick(() => {
        this.colleagueList = this.defaultValue.colleagueDOS != null ? this.defaultValue.colleagueDOS.map(e => {
          return e.id
        }) : []
        defaultValue.projectEndtime = defaultValue.projectEndtime != '~' ? this.$moment(defaultValue.projectEndtime) : undefined
        // defaultValue.dealSourceTree = [defaultValue.dealSourceVO.sourceType,defaultValue.dealSourceVO.sourcePath]
        defaultValue.dealSourcePersonStringList = this.dealSourcePersonStringList
        defaultValue.dealType = defaultValue.dealType.split(',')
        if (defaultValue.targetArea != '~') {
          defaultValue.targetArea = JSON.parse(defaultValue.targetArea)
        } else {
          defaultValue.targetArea = null
        }
        this.form.setFieldsValue(defaultValue)
      })
    },
    initCompetitors() {
      colleagueApi.selectAll().then(res => {
        if (res.code == 1) {
          this.competitors = res.data.records
        }
      })
    },
    initPropertyTypes() {
      this.propertyTypes = [];
      let propertyTypes = this.$t('deal.propertyTypes')
      for (var p in propertyTypes) {
        this.propertyTypes.push({wordKey: p, wordValue: propertyTypes['' + p]})
      }
    },
    initDealTypes() {
      this.dealTypes = [];
      let dealTypes = this.$t('deal.dealTypes')
      for (var p in dealTypes) {
        if (p != '项目咨询与顾问') {
          this.dealTypes.push({wordKey: p, wordValue: dealTypes['' + p]})
        }
      }
    },
    submit() {
      let dealDO
      let pass = true
      this.form.validateFieldsAndScroll(err => {
        if (err) {
          pass = false
        }
      })
      if (!pass) {
        return
      }
      dealDO = this.form.getFieldsValue()
      dealDO.projectPossible = this.currProjectPossible;
      if (dealDO.projectEndtime != null) {
        dealDO.projectEndtime = new Date(this.$moment(dealDO.projectEndtime, 'YYYY-MM-DD').format('YYYY-MM-DD'));
      }
      if (this.defaultValue.dealOriginType != 2) {
        dealDO.dealSourceVO.dealSourcePersonDOS = dealDO.dealSourcePersonStringList.map(e => {
          return {userId: e}
        })
        dealDO.colleagueDOS = this.colleagueList.map(e => {
          return {id: e}
        })
      }
      if (dealDO.dealType) {
        dealDO.dealType = dealDO.dealType.join(',')
      }
      dealDO.id = this.defaultValue.id
      dealDO.depId = this.defaultValue.depId
      dealDO.version = this.defaultValue.version
      if (dealDO.targetArea) {
        dealDO.targetArea = JSON.stringify(dealDO.targetArea)
      }
      dealApi.updateDealDetails(dealDO).then(res => {
        if (res.code == 1) {
          this.$message.success(res.message)
          this.$emit('updateDealDetailsSuccess')
          this.editMode = false
        } else {
          this.$message.error(res.message)
        }
      })
    },
    saveCustomerSuccess(id, name, customer) {
      this.setDefaultCustomerDO(id, name, customer);
      this.customerModalVisible = false;
    },
    saveProprietorSuccess(id, name, customer) {
      this.setDefaultCustomerDO(id, name, customer);
      this.proprietorModalVisible = false;
    },
    openAddCustomerModal() {
      if (this.customerType == 1) {
        this.customerModalVisible = true;
      } else {
        this.proprietorModalVisible = true
      }
    },
    saveCustomer() {
      if (this.customerType == 1) {
        this.$refs.customerModel.submit();
      } else {
        this.$refs.addProprietorRef.submit()
      }
    },
    cancelAddCustomer() {
      this.proprietorModalVisible = false
      this.customerModalVisible = false;
    },
    setDefaultCustomerDO(id, name, customer) {
      this.customerList = [];
      let customerDO = {
        id: id,
        companyName: name,
        companySortNameCn: customer.companySortNameCn
      }
      this.customerList.push(customerDO);
      this.form.setFieldsValue({
        customerId: id
      })
      this.buildProjectNameByCustomer(id);
    },
  },
  watch: {
    dealDetailsEditVisible() {
      this.init();
    }
  }
}
</script>

<style scoped lang="less">
@import '../../../core/diy.less';

#dealDetailsComponent {
  .blackhillsYellow {
    color: @blackhills-yellow !important;
  }

  .customer_name {
    font-size: 17px;
    color: #333333;
    margin-bottom: 10px;
    font-weight: bold;
  }

  .info_lines {
    padding-bottom: 15px;
  }

  .title {
    font-size: 12px;
    color: #999999;
  }

  .content_text {
    font-size: 12px;
    color: #333333;
  }

  .edit_icon {
    font-size: 18px;
    float: right;
    cursor: pointer;
  }

  .ant-form-vertical .ant-form-item {
    padding: 0 10px;
  }

  .save_buttons {
    display: flex;
    justify-content: flex-end;
    padding-top: 5px;
  }

  .save_form {
    padding: 18px 10px 0 10px;
  }
}

.addCustomerBtn {
  background: #3B2E26;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  height: 30px;

  .addIcon {
    color: #ffffff;
    font-size: 12px;
  }
}

/deep/ .invisible-item {
  display: none;
}
</style>
<style lang="less">
.ant-select-dropdown-content {
  /deep/ .invisible-item {
    display: initial !important;
  }
}
</style>